import { Component, OnInit, VERSION, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, FormArray } from '@angular/forms';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { IPropertyRevisionModel, PropertyRevisionModel } from '../../../shared/models/IPropertyRevisionModel';
import { CommonService } from '../../../shared/providers/common.service';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';
import { IPropertyDetails } from '../../../shared/models/propertydetails';
import { PropertySalesInputModel, PropertyDocument } from '../../../shared/models/SavePropertyInputModel';
import { ToastService } from '../../../shared/providers/toast.service';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { IFileUpload } from '../../../shared/models/fileupload';
import { LoaderService } from '../../../shared/providers/loader.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
/*import { CompleterData, CompleterService } from 'ng2-completer';*/
import { RestService } from '../../../shared/providers/rest.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { SharedService } from '../../../shared/providers/shared.service';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { catchError, distinctUntilChanged, Observable, of, Subject, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-property-revisions-add',
  templateUrl: './property-revisions-add.component.html',
  styleUrls: ['./property-revisions-add.component.css'],
})


export class PropertyRevisionsAddComponent implements OnInit {
  constructor(public validationService: ValidationService, private propertyManagementService: PropertyManagementService, private readonly formBuilder: FormBuilder,
    private _commonService: CommonService, private toastService: ToastService, private _fileUploadService: FileUploadService,
    private _loaderService: LoaderService, private _authenticationService: AuthenticationService, private http: HttpClient,
    /*private completerService: CompleterService, */private _restService: RestService, private _sharedService: SharedService) {
    //const remoteDataProvider = completerService.remote(_restService.getBaseUrl + '/property/tenants/', 'TenantName', 'TenantName');
    //remoteDataProvider.urlFormater(x => {
    //  return encodeURI(_restService.getBaseUrl + '/property/tenants?searchText=' + encodeURIComponent(x));
    //});
    //this.dataService = remoteDataProvider;
    this.loadItems();

  }
  formTemplate: IPropertyRevisionModel[];
  TenantName = null;
  @Output() savehistory = new EventEmitter();
  @Output() save = new EventEmitter();
  fileTypes = '.PDF, .XLSX, .XLS, .DOCX, .DOC, .TXT, .DWG'
  @Output() close = new EventEmitter();
  @Input() property: IPropertyDetails;
  @Input() currentSalesDetails;
  @Input() IsDataEntryProperty = false;
  @Input() IsFromAddEditPage = true;;
  propertyRevisionModel: PropertyRevisionModel;
  dcmt = {} as PropertyDocument;
  isShowForm = false;
  lookupData: ILookUp[];
  user: any;
  inputFileUpload = {} as IFileUpload;
  removedDocIds: number[] = [];
  formGroup: FormGroup;
  eventTypeId: number = null;
  portfolioProperties = [] as any[];
  @Input() transactionTypeId: number = 6500;
  @Input() revisionId: number = 0;
  documents: PropertyDocument[] = [];
  SaleHistoryRentTerm = [];
  capRateValidationText = "";
  askingPriceValidationText = "";
  SaleDate = new Date();
  fileExtensionType = "document";
  fileUploadType = "multiple";
  dataService: [];/*CompleterData;*/
  defaultTypeSettings = {
    dynamicTitleMaxItems: 1
  };
  dataService$: Observable<any[]>;
  dataServiceInput$ = new Subject<string>();
  loading = false;
  //defaultTypeText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Select'
  //};

  ngOnInit() {
    this.user = this._authenticationService.user;
    this.IsFromAddEditPage = true;
    this.LoadEventTypes();
    this.GetPropertyRevisionFields();
    this.bindTable();
   }

  private loadItems() {
    this.dataService$ = this.dataServiceInput$.pipe(
      distinctUntilChanged(),
      tap(() => this.loading = true),
      switchMap(term => this.getItems(term).pipe(
        catchError(() => of([])), // empty list on error
        tap(() => this.loading = false)
      ))
    )
  }

  getItems(term: any = null): Observable<any[]> {
    return this.propertyManagementService.getTenantList(term);
  }
  onSubmit() {
    if (this.capRateValidationText != '' || this.askingPriceValidationText != '') {
      this.toastService.addToast({
        title: 'Unable to save changes',
        msg: 'One or more validations are pending',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });

      return;
    }

    if (this.propertyRevisionModel.EventTypeId != null && (typeof this.propertyRevisionModel.EventTypeId === 'number')) {
      this._loaderService.display(true);
      this.SavePropertyRevisions(this.formGroup.value["formFields"]);
    }
    else {
      this.toastService.addToast({
        title: 'Success',
        msg: 'Select an event type',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
    }
  }

  GetPropertyRevisionFields() {
    this.propertyManagementService.GetPropertyRevisionFields(this.revisionId, this.transactionTypeId).subscribe(response => {
      this.propertyRevisionModel = response;
      this.propertyRevisionModel.TransactionTypeId = this.transactionTypeId;

      if (this.propertyRevisionModel != null && this.propertyRevisionModel.PropertyRevisionFieldModels != null) {
        this.propertyRevisionModel.PropertyRevisionFieldModels.forEach(item => {
          if (item.DataType == 'Datetime' && item.NewValue != null) {
            let utcDate = item.NewValue;
            if (!this.validationService.IsinValid(utcDate) && utcDate != null) {
              var date = this.validationService.convertUTCDateToLocalDate1(utcDate);
              item.NewValue = date;
            }
          }
        });
     
      }

      this.formTemplate = this.propertyRevisionModel.PropertyRevisionFieldModels;
      this.propertyRevisionModel.EventTypeId = this.propertyRevisionModel.EventTypeId == 0 ? null : this.propertyRevisionModel.EventTypeId;
      this.revisionId = this.propertyRevisionModel.RevisionId;
      this.formGroup = this.formBuilder.group({
        formFields: this.formBuilder.array(this.formTemplate.filter(i => i.ParentId == null).map(elem => this.createMemberGroup(elem)))
      });
      if (this.revisionId == 0 && this.transactionTypeId == 6500) {
        this.propertyRevisionModel.EventTypeId = 6302;
        this.setAutoCalcFieldsChecked();
        this.setDefaultValues();
      }
      this.isShowForm = true;
    });
  }

  setAutoCalcFieldsChecked() {

    this.revisionModelList = this.formGroup.value["formFields"];
    let capRate = this.revisionModelList.filter(c => c.Name == "Sale Cap Rate")[0];
    var index = this.revisionModelList.indexOf(capRate);
    let childArr = this.childFields(index);
    childArr.at(0).patchValue({ Value: true, NewValue: true });
    childArr.updateValueAndValidity();

    let psf = this.revisionModelList.filter(c => c.Name == "PSF")[0];
    var indexPsf = this.revisionModelList.indexOf(psf);
    let childArrPSF = this.childFields(indexPsf);
    childArrPSF.at(0).patchValue({ Value: true, NewValue: true });
    childArrPSF.updateValueAndValidity();

    let discount = this.revisionModelList.filter(c => c.Name == "Discount To Asking")[0];
    var indexDiscount = this.revisionModelList.indexOf(discount);
    let childArrDiscount = this.childFields(indexDiscount);
    childArrDiscount.at(0).patchValue({ Value: true, NewValue: true });
    childArrDiscount.updateValueAndValidity();
  }

  SavePropertyRevisions(data: IPropertyRevisionModel[]) {
    this.propertyRevisionModel.PropertyRevisionFieldModels = data;
    this.propertyRevisionModel.PropertyIds = this.selectedProps;
    let UTCDate = (this.propertyRevisionModel.PropertyRevisionFieldModels.filter(i => i.Name == "Date")[0].NewValue);
    this.propertyRevisionModel.LoggedInUserId = this.user.Id;
    this.propertyRevisionModel.IsDEProperty = this.IsDataEntryProperty;
    this.propertyRevisionModel.TransactionTypeId = this.transactionTypeId;

    if ((this.property == undefined || this.property.Id == 0) && !this.IsDataEntryProperty) {
      this.savehistory.emit(this.propertyRevisionModel);
      this.onClose(null);
    }
    else {
      //if (!this.validationService.IsinValid(UTCDate)) {
      //  var date = new Date(UTCDate + ' UTC');
      //  this.propertyRevisionModel.PropertyRevisionFieldModels.filter(i => i.Name == "Date")[0].NewValue = date;
      //}
      //this.propertyRevisionModel.PropertyRevisionFieldModels.filter(i => i.Name == "Date")[0].NewValue = this.validationService.convertUTCDateToLocalDate(this.propertyRevisionModel.PropertyRevisionFieldModels.filter(i => i.Name == "Date")[0].NewValue);
      this.propertyRevisionModel.PropertyId = this.property.Id;
      this.propertyManagementService.SavePropertyRevision(this.propertyRevisionModel).subscribe(response => {
        if (response && this.propertyRevisionModel.SelectedFiles != null && this.propertyRevisionModel.SelectedFiles.length > 0) {
          let uploadCount = 1;
          this.propertyRevisionModel.SelectedFiles.forEach(item => {

            this.inputFileUpload.documentName = item["name"];
            this.inputFileUpload.fileCategoryId = 401;
            this.inputFileUpload.id = 0;
            this.inputFileUpload.objectId = response ? Number(response) : 0;
            this.inputFileUpload.objectTypeId = 309;
            this.inputFileUpload.type = "Documents";

            let fileToUpload = [];
            fileToUpload.push(item);
            this._fileUploadService.uploadFiles(this.inputFileUpload, fileToUpload).subscribe(res => {
              if (res != null) {
                if (uploadCount == this.propertyRevisionModel.SelectedFiles.length) {
                  this.toastService.addToast({ title: 'Success', msg: "Property Revision Added Successfully", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                  this.onClose(null);
                  this.save.emit();
                  this._sharedService.addRevision(response);
                }
                uploadCount++;
              }
            });
          });
        }
        else {
          this.toastService.addToast({ title: 'Success', msg: "Property Revision Added Successfully", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.onClose(null);
          this.save.emit();
          this._sharedService.addRevision(response);
        }
      });
    }
  }

  createMemberGroup(member: IPropertyRevisionModel): FormGroup {
    return this.formBuilder.group({
      ...member,
      ...{
        Value: [member.DataType == 'Datetime' && member.Value != null ? new Date(member.Value) : (member.DataType == 'Dropdown' && member.Value != null ? Number(member.Value) : member.Value)],
        NewValue: [member.DataType == 'Datetime' && member.NewValue != null ? new Date(member.NewValue) : (member.DataType == 'Dropdown' && member.NewValue != null ? Number(member.NewValue) : member.NewValue)],
        DropDownData: [member.DataType == 'Dropdown' ? this.LoadDropdownData(member.Id) : []],
        ChildItems: this.LoadChild(member.Id)
      }
    });
  }

  fields(): FormArray {
    return this.formGroup.get("formFields") as FormArray
  }

  onNewDateSelection(event, item) {

    switch (item.Name) {
      case "Date": {
        this.newCalcDateOnMarket();
        this.newRemainingTerm();
        break;
      }
      case "Property Brought To Market": {
        this.newCalcDateOnMarket();
        break;
      }
      case "Lease Expiration": {
        this.newRemainingTerm();
        break;
      }
    }
  }

  setDefaultValues() {
    
    this.revisionModelList = this.formGroup.value["formFields"];
    let askingPrice = this.revisionModelList.filter(c => c.Name == "Asking Price")[0];
    var index = this.revisionModelList.indexOf(askingPrice);
    var capRate = this.revisionModelList.filter(i => i.Name == "Asking Cap Rate")[0];
    var capRateIndex = this.revisionModelList.indexOf(capRate);
    var dateOnMarket = this.revisionModelList.filter(i => i.Name == "Property Brought To Market")[0];
    var dateOnMarketIndex = this.revisionModelList.indexOf(dateOnMarket);
    var leaseExpiration = this.revisionModelList.filter(i => i.Name == "Lease Expiration")[0];
    var leaseExpirationIndex = this.revisionModelList.indexOf(leaseExpiration);
    var noi = this.revisionModelList.filter(i => i.Name == "NOI")[0];
    var noiIndex = this.revisionModelList.indexOf(noi);
    var sellerBrokerage = this.revisionModelList.filter(i => i.Name == "Seller Brokerage")[0];
    var sellerBrokerageIndex = this.revisionModelList.indexOf(sellerBrokerage);
    var rentEscalationPercentage = this.revisionModelList.filter(i => i.Name == "Rent Escalation Percentage")[0];
    var rentEscalationPercentageIndex = this.revisionModelList.indexOf(rentEscalationPercentage);
    var Guarantor = this.revisionModelList.filter(i => i.Name == "Guarantor")[0];
    var GuarantorIndex = this.revisionModelList.indexOf(Guarantor);
    var spRating = this.revisionModelList.filter(i => i.Name == "SP Rating")[0];
    var spRatingIndex = this.revisionModelList.indexOf(spRating);
    var moodyRating = this.revisionModelList.filter(i => i.Name == "Moody Rating")[0];
    var moodyRatingIndex = this.revisionModelList.indexOf(moodyRating);
    var fitchRating = this.revisionModelList.filter(i => i.Name == "Fitch Rating")[0];
    var fitchRatingeIndex = this.revisionModelList.indexOf(fitchRating);


    var rentEscalationPeriod = this.revisionModelList.filter(i => i.Name == "Rent Escalation Period")[0];
    var rentEscalationPeriodIndex = this.revisionModelList.indexOf(rentEscalationPeriod);
    var optionNumber = this.revisionModelList.filter(i => i.Name == "Option Number")[0];
    var optionNumberIndex = this.revisionModelList.indexOf(optionNumber);
    var optionLength = this.revisionModelList.filter(i => i.Name == "Option Length")[0];
    var optionLengthIndex = this.revisionModelList.indexOf(optionLength);

    let formArr = this.formGroup.get("formFields") as FormArray;

    formArr.at(index).patchValue({ NewValue: this.property.Price });
    formArr.at(capRateIndex).patchValue({ NewValue: this.property.CapRate });
    if (this.property.DateOnMarket != null) {
      formArr.at(dateOnMarketIndex).patchValue({ NewValue: new Date(this.property.DateOnMarket) });
    }

    if (this.property != undefined && this.property.LeaseExpiration != null) {
      formArr.at(leaseExpirationIndex).patchValue({ NewValue: new Date(this.property.LeaseExpiration) });
    }

    formArr.at(noiIndex).patchValue({ NewValue: this.property.NOI });
    if (this.property.BrokersId != null && this.property.BrokerageId > 0) {
      formArr.at(sellerBrokerageIndex).patchValue({ NewValue: this.property.BrokerageId });
    }
    formArr.at(rentEscalationPercentageIndex).patchValue({ NewValue: this.property.RentEscalationPercentage });
    formArr.at(rentEscalationPeriodIndex).patchValue({ NewValue: this.property.RentEscalationPeriod });
    formArr.at(optionNumberIndex).patchValue({ NewValue: this.property.OptionNumber });
    formArr.at(optionLengthIndex).patchValue({ NewValue: this.property.OptionLength });

    var psf = this.revisionModelList.filter(i => i.Name == "PSF")[0];
    var index = this.revisionModelList.indexOf(psf);
    var value = parseFloat(((Number(this.property.Price) / Number(this.property.BuildingSize))).toFixed(2));
    formArr.at(index).patchValue({ NewValue: value });

    if (this.property.GuarantorId != null && this.property.GuarantorId > 0) {
      formArr.at(GuarantorIndex).patchValue({ NewValue: this.property.GuarantorId });
    }

    if (this.property.MoodyRatingId != null && this.property.MoodyRatingId > 0) {
      formArr.at(moodyRatingIndex).patchValue({ NewValue: this.property.MoodyRatingId });
    }

    if (this.property.FitchRatingId != null && this.property.FitchRatingId > 0) {
      formArr.at(fitchRatingeIndex).patchValue({ NewValue: this.property.FitchRatingId });
    }

    if (this.property.SPRatingId != null && this.property.SPRatingId > 0) {
      formArr.at(spRatingIndex).patchValue({ NewValue: this.property.SPRatingId });
    }

    formArr.updateValueAndValidity();
    this.newRemainingTerm();
    this.newCalcDateOnMarket();
  }

  clearDefaultValues() {
    this.revisionModelList = this.formGroup.value["formFields"];
    let askingPrice = this.revisionModelList.filter(c => c.Name == "Asking Price")[0];
    var index = this.revisionModelList.indexOf(askingPrice);
    var capRate = this.revisionModelList.filter(i => i.Name == "Asking Cap Rate")[0];
    var capRateIndex = this.revisionModelList.indexOf(capRate);
    var dateOnMarket = this.revisionModelList.filter(i => i.Name == "Property Brought To Market")[0];
    var dateOnMarketIndex = this.revisionModelList.indexOf(dateOnMarket);
    var noi = this.revisionModelList.filter(i => i.Name == "NOI")[0];
    var noiIndex = this.revisionModelList.indexOf(noi);
    var sellerBrokerage = this.revisionModelList.filter(i => i.Name == "Seller Brokerage")[0];
    var sellerBrokerageIndex = this.revisionModelList.indexOf(sellerBrokerage);
    var rentEscalationPercentage = this.revisionModelList.filter(i => i.Name == "Rent Escalation Percentage")[0];
    var rentEscalationPercentageIndex = this.revisionModelList.indexOf(rentEscalationPercentage);

    var rentEscalationPeriod = this.revisionModelList.filter(i => i.Name == "Rent Escalation Period")[0];
    var rentEscalationPeriodIndex = this.revisionModelList.indexOf(rentEscalationPeriod);
    var optionNumber = this.revisionModelList.filter(i => i.Name == "Option Number")[0];
    var optionNumberIndex = this.revisionModelList.indexOf(optionNumber);
    var optionLength = this.revisionModelList.filter(i => i.Name == "Option Length")[0];
    var optionLengthIndex = this.revisionModelList.indexOf(optionLength);

    var Guarantor = this.revisionModelList.filter(i => i.Name == "Guarantor")[0];
    var GuarantorIndex = this.revisionModelList.indexOf(Guarantor);
    var spRating = this.revisionModelList.filter(i => i.Name == "SP Rating")[0];
    var spRatingIndex = this.revisionModelList.indexOf(spRating);
    var moodyRating = this.revisionModelList.filter(i => i.Name == "Moody Rating")[0];
    var moodyRatingIndex = this.revisionModelList.indexOf(moodyRating);
    var fitchRating = this.revisionModelList.filter(i => i.Name == "Fitch Rating")[0];
    var fitchRatingeIndex = this.revisionModelList.indexOf(fitchRating);

    let formArr = this.formGroup.get("formFields") as FormArray;

    if (index > -1)
      formArr.at(index).patchValue({ NewValue: "" });
    if (capRateIndex > -1)
      formArr.at(capRateIndex).patchValue({ NewValue: "" });
    if (dateOnMarketIndex > -1)
      formArr.at(dateOnMarketIndex).patchValue({ NewValue: null });
    if (noiIndex > -1)
      formArr.at(noiIndex).patchValue({ NewValue: "" });
    if (sellerBrokerageIndex > -1)
      formArr.at(sellerBrokerageIndex).patchValue({ NewValue: null });


    if (rentEscalationPercentageIndex > -1)
      formArr.at(rentEscalationPercentageIndex).patchValue({ NewValue: "" });
    if (rentEscalationPeriodIndex > -1)
      formArr.at(rentEscalationPeriodIndex).patchValue({ NewValue: "" });
    if (optionNumberIndex > -1)
      formArr.at(optionNumberIndex).patchValue({ NewValue: "" });
    if (optionLengthIndex > -1)
      formArr.at(optionLengthIndex).patchValue({ NewValue: "" });
    if (GuarantorIndex > -1)
      formArr.at(GuarantorIndex).patchValue({ NewValue: null });
    if (moodyRatingIndex > -1)
      formArr.at(moodyRatingIndex).patchValue({ NewValue: null });
    if (fitchRatingeIndex > -1)
      formArr.at(fitchRatingeIndex).patchValue({ NewValue: null });
    if (spRatingIndex > -1)
      formArr.at(spRatingIndex).patchValue({ NewValue: null });


    formArr.updateValueAndValidity();
    this.newRemainingTerm(true);
  }

  eventChanged() {
    if (this.propertyRevisionModel.EventTypeId == 6302 && this.propertyRevisionModel.RevisionId == 0) {
      this.setDefaultValues();
    }
    else if (this.propertyRevisionModel.RevisionId == 0) {

      this.clearDefaultValues();
    }
  }

  newRemainingTerm(clear = false) {
    this.revisionModelList = this.formGroup.value["formFields"];
    let time_on_Market = this.revisionModelList.filter(c => c.Name == "Remaining Term")[0];
    var index = this.revisionModelList.indexOf(time_on_Market);
    let leaseExpirationDate = this.validationService.convertUTCDateToLocalDate(this.property.LeaseExpiration);

    if (this.revisionModelList.filter(c => c.Name == "Lease Expiration")[0] != null && this.revisionModelList.filter(c => c.Name == "Lease Expiration")[0] != undefined) {
      let leaseDate = this.revisionModelList.filter(c => c.Name == "Lease Expiration")[0].NewValue;
      if (leaseDate != null && leaseDate != undefined) {
        leaseExpirationDate = this.validationService.convertUTCDateToLocalDate(leaseDate);
      }
    }

    let ymd;

    if (this.revisionModelList.filter(c => c.Name == "Date")[0] != null && this.revisionModelList.filter(c => c.Name == "Date")[0] != undefined) {
      let currentDate = this.revisionModelList.filter(c => c.Name == "Date")[0].NewValue;
      if (currentDate != null && currentDate != undefined) {
        currentDate = this.validationService.convertUTCDateToLocalDate(currentDate);
        ymd = this.validationService.ExcatYearMonthDaysBetweenDates(leaseExpirationDate, currentDate);
      }
      else {
        let newDate = new Date();
        newDate.setHours(0, 0, 0, 0);
        ymd = this.validationService.ExcatYearMonthDaysBetweenDates(leaseExpirationDate, newDate);
      }
    }
    else {
      if (this.propertyRevisionModel.RevisionId == 0) {
        let newDate = new Date();
        newDate.setHours(0, 0, 0, 0);
        ymd = this.validationService.ExcatYearMonthDaysBetweenDates(leaseExpirationDate, newDate);
      }
      else {
        let addedDate = this.validationService.convertUTCDateToLocalDate(this.propertyRevisionModel.EntryDate);
        ymd = this.validationService.ExcatYearMonthDaysBetweenDates(leaseExpirationDate, addedDate);
      }
      
    }

    let formArr = this.formGroup.get("formFields") as FormArray;
    let childArr = this.childFields(index);
    if (ymd && !clear) {
      let ymdSplit = ymd.split('|');
      if (ymdSplit[0]) {
        formArr.at(index).patchValue({ NewValue: Number(ymdSplit[0]) });
      }

      if (ymdSplit[1]) {
        childArr.at(0).patchValue({ NewValue: Number(ymdSplit[1]) });
      }

      if (ymdSplit[2]) {
        childArr.at(1).patchValue({ NewValue: Number(ymdSplit[2]) });
      }

      childArr.updateValueAndValidity();
      formArr.updateValueAndValidity();

    }
    else {
      formArr.at(index).patchValue({ NewValue: "" });



      childArr.at(0).patchValue({ NewValue: "" });



      childArr.at(1).patchValue({ NewValue: "" });


      childArr.updateValueAndValidity();
      formArr.updateValueAndValidity();
    }
  }

  newCalcDateOnMarket() {
    this.revisionModelList = this.formGroup.value["formFields"];
    let time_on_Market = this.revisionModelList.filter(c => c.Name == "Time on Market")[0];
    var index = this.revisionModelList.indexOf(time_on_Market);
    var saleDate = this.revisionModelList.filter(i => i.Name == "Date")[0];
    var dateOnMarket = this.revisionModelList.filter(i => i.Name == "Property Brought To Market")[0];

    if (saleDate.NewValue == null && dateOnMarket.NewValue != null) {
      let ymd;
      if (this.propertyRevisionModel.RevisionId == 0) {
        let date = new Date();
        ymd = this.validationService.ExcatYearMonthDaysBetweenDates(date, dateOnMarket.NewValue);
      }
      else {
        ymd = this.validationService.ExcatYearMonthDaysBetweenDates(this.propertyRevisionModel.EntryDate, dateOnMarket.NewValue);
      }
     
      let formArr = this.formGroup.get("formFields") as FormArray;
      let childArr = this.childFields(index);
      if (ymd) {
        let ymdSplit = ymd.split('|');
        if (ymdSplit[0]) {
          formArr.at(index).patchValue({ NewValue: Number(ymdSplit[0]) });
        }

        if (ymdSplit[1]) {
          childArr.at(0).patchValue({ NewValue: Number(ymdSplit[1]) });
        }

        if (ymdSplit[2]) {
          childArr.at(1).patchValue({ NewValue: Number(ymdSplit[2]) });
        }

        childArr.updateValueAndValidity();
        formArr.updateValueAndValidity();
      }
    }
    else if (saleDate.NewValue != null && dateOnMarket.NewValue != null) {
      let ymd = this.validationService.ExcatYearMonthDaysBetweenDates(saleDate.NewValue, dateOnMarket.NewValue);
      let formArr = this.formGroup.get("formFields") as FormArray;
      let childArr = this.childFields(index);
      if (ymd) {
        let ymdSplit = ymd.split('|');
        if (ymdSplit[0]) {
          formArr.at(index).patchValue({ NewValue: Number(ymdSplit[0]) });
        }

        if (ymdSplit[1]) {
          childArr.at(0).patchValue({ NewValue: Number(ymdSplit[1]) });
        }

        if (ymdSplit[2]) {
          childArr.at(1).patchValue({ NewValue: Number(ymdSplit[2]) });
        }

        childArr.updateValueAndValidity();
        formArr.updateValueAndValidity();
      }
    }
  }

  childFields(index: number): FormArray {
    return this.fields().at(index).get("ChildItems") as FormArray
  }

  LoadEventTypes() {
    var lookupTypeId = this.transactionTypeId == 6500 ? 50 : 39;
    this._commonService.getLookupsByTypeId(lookupTypeId).subscribe(response => {
      this.lookupData = response.filter(i => (this.transactionTypeId == 6500 && i.Id == 6302) || this.transactionTypeId == 6501).map(o => {
        return { id: o.Id, description: o.Description };
      });
    });
  }

  revisionModelList: IPropertyRevisionModel[];

  autoCalcNewValue(event, item) {

    if (event.currentTarget.checked) {
      switch (item.Name) {
        case "Auto Calc Cap Rate": {
          this.revisionModelList = this.formGroup.value["formFields"];
          var capRate = this.revisionModelList.filter(i => i.Name == "Sale Cap Rate")[0];
          var salePrice = this.revisionModelList.filter(i => i.Name == "Sale Price")[0];
          var noi = this.revisionModelList.filter(i => i.Name == "NOI")[0];
          var value = parseFloat(((parseFloat(noi.NewValue) / parseFloat(salePrice.NewValue)) * 100).toFixed(2));
          let formArr = this.formGroup.get("formFields") as FormArray;
          var index = this.revisionModelList.indexOf(capRate);
          value = Number(value) > 100 ? 100 : (value < 0 ? 0 : value);
          formArr.at(index).patchValue({ NewValue: value });
          formArr.updateValueAndValidity();
          break;
        }
        case "Auto Calc PSF": {
          this.revisionModelList = this.formGroup.value["formFields"];
          var psf = this.revisionModelList.filter(i => i.Name == "PSF")[0];
          let formArr = this.formGroup.get("formFields") as FormArray;
          var index = this.revisionModelList.indexOf(psf);
          var askingPrice = this.revisionModelList.filter(i => i.Name == "Asking Price")[0];
          var value = parseFloat(((parseFloat(askingPrice.NewValue) / Number(this.property.BuildingSize))).toFixed(2));
          formArr.at(index).patchValue({ NewValue: value });
          formArr.updateValueAndValidity();
          break;
        }
        case "Auto Calc Discount": {
          
          this.revisionModelList = this.formGroup.value["formFields"];
          var psf = this.revisionModelList.filter(i => i.Name == "Discount To Asking")[0];
          let formArr = this.formGroup.get("formFields") as FormArray;
          var index = this.revisionModelList.indexOf(psf);
          var askingPrice = this.revisionModelList.filter(i => i.Name == "Asking Price")[0];
          var salePrice = this.revisionModelList.filter(i => i.Name == "Sale Price")[0];
          var netPercentage = parseFloat(((parseFloat(salePrice.NewValue.toString()) / parseFloat(askingPrice.NewValue.toString())) * 100).toFixed(2));
          var discount = 100 - Number(netPercentage);
          discount = Number(discount) > 100 ? 100 : (discount < 0 ? 0 : discount);
          formArr.at(index).patchValue({ NewValue: discount });
          formArr.updateValueAndValidity();
          break;
        }
        default: {
          //statements; 
          break;
        }
      }


    }
    else {
      switch (item.Name) {
        case "Auto Calc Cap Rate": {
          this.revisionModelList = this.formGroup.value["formFields"];
          var capRate = this.revisionModelList.filter(i => i.Name == "Sale Cap Rate")[0];
          let formArr = this.formGroup.get("formFields") as FormArray;
          var index = this.revisionModelList.indexOf(capRate);
          formArr.at(index).patchValue({ NewValue: null });
          formArr.updateValueAndValidity();
          break;
        }
        case "Auto Calc PSF": {
          this.revisionModelList = this.formGroup.value["formFields"];
          var psf = this.revisionModelList.filter(i => i.Name == "PSF")[0];
          let formArr = this.formGroup.get("formFields") as FormArray;
          var index = this.revisionModelList.indexOf(psf);
          formArr.at(index).patchValue({ NewValue: null });
          formArr.updateValueAndValidity();
          break;
        }
        default: {
          //statements; 
          break;
        }
      }
    }
  }

  newValueChange(item) {
    
    switch (item.Name) {
      case "Sale Price": {
        this.revisionModelList = this.formGroup.value["formFields"];
        let discountAsking = this.revisionModelList.filter(c => c.Name == "Discount To Asking").map(p => p.ChildItems)[0];
        let capRateChild = this.revisionModelList.filter(c => c.Name == "Sale Cap Rate").map(p => p.ChildItems)[0];
        var isAutoCalc = capRateChild?.filter(i => i.Name == "Auto Calc Cap Rate")[0];
        var isAutoCalcDiscount = discountAsking.filter(i => i.Name == "Auto Calc Discount")[0];
        var salePrice = this.revisionModelList.filter(i => i.Name == "Sale Price")[0];
        if (isAutoCalc.NewValue == true) {
          var capRate = this.revisionModelList.filter(i => i.Name == "Sale Cap Rate")[0];
          var noi = this.revisionModelList.filter(i => i.Name == "NOI")[0];
          var value = parseFloat(((parseFloat(noi.NewValue) / parseFloat(salePrice.NewValue)) * 100).toFixed(2));
          let formArr = this.formGroup.get("formFields") as FormArray;
          var index = this.revisionModelList.indexOf(capRate);
          value = Number(value) > 100 ? 100 : (value < 0 ? 0 : value);
          formArr.at(index).patchValue({ NewValue: value });
          formArr.updateValueAndValidity();
        }

        if (isAutoCalcDiscount.NewValue == true) {
          let formArr = this.formGroup.get("formFields") as FormArray;
          var discountField = this.revisionModelList.filter(i => i.Name == "Discount To Asking")[0];
          var indexDiscount = this.revisionModelList.indexOf(discountField);
          var askingPrice = this.revisionModelList.filter(i => i.Name == "Asking Price")[0];
          var netPercentage = parseFloat(((parseFloat(salePrice.NewValue) / parseFloat(askingPrice.NewValue)) * 100).toFixed(2));
          var discount = 100 - Number(netPercentage);
          discount = Number(discount) > 100 ? 100 : (discount < 0 ? 0 : discount);
          formArr.at(indexDiscount).patchValue({ NewValue: discount });
          formArr.updateValueAndValidity();
        }
        break;
      }
      case "NOI": {
        this.revisionModelList = this.formGroup.value["formFields"];
        let capRateChild = this.revisionModelList.filter(c => c.Name == "Sale Cap Rate").map(p => p.ChildItems)[0];
        var isAutoCalc = capRateChild?.filter(i => i.Name == "Auto Calc Cap Rate")[0];
        if (isAutoCalc.NewValue == true || isAutoCalc.NewValue == "True") {
          var capRate = this.revisionModelList.filter(i => i.Name == "Sale Cap Rate")[0];
          var salePrice = this.revisionModelList.filter(i => i.Name == "Sale Price")[0];
          var noi = this.revisionModelList.filter(i => i.Name == "NOI")[0];
          var value = parseFloat(((parseFloat(noi.NewValue) / parseFloat(salePrice.NewValue)) * 100).toFixed(2));
          let formArr = this.formGroup.get("formFields") as FormArray;
          var index = this.revisionModelList.indexOf(capRate);
          value = Number(value) > 100 ? 100 : (value < 0 ? 0 : value);
          formArr.at(index).patchValue({ NewValue: value });
          formArr.updateValueAndValidity();
        }
        break;
      }
      case "Asking Price": {

        this.revisionModelList = this.formGroup.value["formFields"];
        let capRateChild = this.revisionModelList.filter(c => c.Name == "PSF").map(p => p.ChildItems)[0];
        var isAutoCalc = capRateChild?.filter(i => i.Name == "Auto Calc PSF")[0];
        let discountAsking = this.revisionModelList.filter(c => c.Name == "Discount To Asking").map(p => p.ChildItems)[0];
        var isAutoCalcDiscount = discountAsking.filter(i => i.Name == "Auto Calc Discount")[0];
        var askingPrice = this.revisionModelList.filter(i => i.Name == "Asking Price")[0];
        if (isAutoCalc.NewValue == true) {
          var psf = this.revisionModelList.filter(i => i.Name == "PSF")[0];
          let formArr = this.formGroup.get("formFields") as FormArray;
          var index = this.revisionModelList.indexOf(psf);
          var value = parseFloat((parseFloat(askingPrice.NewValue) / Number(this.property.BuildingSize)).toFixed(2));
          formArr.at(index).patchValue({ NewValue: value });
          formArr.updateValueAndValidity();
        }

        if (isAutoCalcDiscount.NewValue == true) {
          let formArr = this.formGroup.get("formFields") as FormArray;
          var discountField = this.revisionModelList.filter(i => i.Name == "Discount To Asking")[0];
          var indexDiscount = this.revisionModelList.indexOf(discountField);
          var salePrice = this.revisionModelList.filter(i => i.Name == "Sale Price")[0];
          var netPercentage = parseFloat(((parseFloat(salePrice.NewValue) / parseFloat(askingPrice.NewValue)) * 100).toFixed(2));
          var discount = 100 - Number(netPercentage);
          discount = Number(discount) > 100 ? 100 : (discount < 0 ? 0 : discount);
          formArr.at(indexDiscount).patchValue({ NewValue: discount });
          formArr.updateValueAndValidity();
        }
        break;
      }
      case "Sale Cap Rate": {
        this.revisionModelList = this.formGroup.value["formFields"];
        let capRate = this.revisionModelList.filter(c => c.Name == "Sale Cap Rate")[0];
        var index = this.revisionModelList.indexOf(capRate);
        if (Number(capRate.NewValue) > 100) {
          this.capRateValidationText = "Sale Cap Rate percentage cannot be greater than 100"
        }
        else {
          this.capRateValidationText = "";
        }
           
        let childArr = this.childFields(index);
        childArr.at(0).patchValue({ NewValue: false });
        childArr.updateValueAndValidity();

        break;
      }
      case "PSF": {
        this.revisionModelList = this.formGroup.value["formFields"];
        let psf = this.revisionModelList.filter(c => c.Name == "PSF")[0];
        var index = this.revisionModelList.indexOf(psf);
        let childArr = this.childFields(index);
        childArr.at(0).patchValue({ NewValue: false });
        childArr.updateValueAndValidity();

        break;
      }
      case "Discount To Asking": {
        this.revisionModelList = this.formGroup.value["formFields"];
        let psf = this.revisionModelList.filter(c => c.Name == "Discount To Asking")[0];
        var index = this.revisionModelList.indexOf(psf);
        let childArr = this.childFields(index);
        childArr.at(0).patchValue({ NewValue: false });
        childArr.updateValueAndValidity();

        break;
      }
      case "Asking Cap Rate": {
        this.revisionModelList = this.formGroup.value["formFields"];
        let capRate = this.revisionModelList.filter(c => c.Name == "Asking Cap Rate")[0];
        var index = this.revisionModelList.indexOf(capRate);
        if (Number(capRate.NewValue) > 100) {
          this.askingPriceValidationText = "Asking Cap Rate percentage cannot be greater than 100"
        }
        else {
          this.askingPriceValidationText = "";
        }

        let childArr = this.childFields(index);
        childArr.at(0).patchValue({ NewValue: false });
        childArr.updateValueAndValidity();

        break;
      }
    }
  }

  LoadChild(id: number) {
    var item = this.formTemplate.filter(i => i.ParentId == id);
    if (item.length > 0) {
      return this.formBuilder.array(item.map(elem => this.createMemberGroup(elem)))
    }
    else {
      return this.formBuilder.array([]);
    }

  }

  LoadDropdownData(value: number) {
    return this._commonService.getPropertyRevisionFieldLogicData(value).toPromise().then(data => {
      return data.map(o => {
        return { id: o.Value, name: o.Key };
      });
    });
  }

  selectedFilesListEmitter(selectedFilesListEmitter) {

    let files = Object.assign([], selectedFilesListEmitter) as any;
    const that = this;
    if (files.length > 0 && this.propertyRevisionModel.SelectedFiles && this.propertyRevisionModel.SelectedFiles.length > 0 && files.length > this.propertyRevisionModel.SelectedFiles.length && this.IsFromAddEditPage) {
      files.forEach(item => {
        if (that.propertyRevisionModel.SelectedFiles.findIndex(z => z == item) == -1) {
          that.propertyRevisionModel.SelectedFiles.push(item);
        }
      });
    }
    else {
      this.propertyRevisionModel.SelectedFiles = files;
    }
    if (this.IsFromAddEditPage) {
      this.propertyRevisionModel.Documents = this.propertyRevisionModel.Documents == null ? [] : this.propertyRevisionModel.Documents;
      files.forEach(item => {
        if (that.propertyRevisionModel.Documents.findIndex(z => z.File == item) == -1) {
          this.dcmt = {} as PropertyDocument;
          this.dcmt.Id = 0;
          this.dcmt.Name = item.name;
          this.dcmt.Url = '';
          this.dcmt.File = item;
          this.propertyRevisionModel.Documents.push(this.dcmt);
        }
      })
    }
  }

  onRemoveDocument(i: number) {

    const removed = this.propertyRevisionModel.Documents[i];
    this._loaderService.display(true);
    this.propertyManagementService.deleteDocument(removed.Id, this.user.Id).subscribe(response => {
      if (response) {
        this._loaderService.display(false);
        this.toastService.addToast({
          title: 'Success',
          msg: 'Document deleted!',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
      }
    });
    this.removedDocIds.push(removed.Id);

    this.propertyRevisionModel.Documents.splice(i, 1);
    if (this.IsFromAddEditPage) {
      let item = this.propertyRevisionModel.Documents[i].File as any;
      this.propertyRevisionModel.SelectedFiles.splice(1, this.propertyRevisionModel.SelectedFiles.findIndex(x => x == item));
      this.propertyRevisionModel.Documents.splice(i, 1);

    }
  }

  onClose(event) {
    this._loaderService.display(false);
    this.revisionId = 0;
    this.close.emit();
  }

  TableColumns = [];
  dtOptions = {};
  selectAll = false;
  protected readonly BASE_URL: string = environment.base_url;

  bindTable() {

    this.TableColumns = [
      { data: 'Id' },
      { data: 'TenantName' },
      { data: 'OM', orderable: false },
      { data: 'State' },
      { data: 'City' },
      //{ data: 'PropertyType' },
      { data: 'PropertyStatus' },
      { data: 'Price' },
      { data: 'RentNOI' },
      { data: 'CapRate' },
      { data: 'RemainingTerm' },
      { data: 'Rank' }]

    //{ data: 'CapRate' },
    //{ data: 'RemainingTerm' },
    //{ data: 'BuildingSize' },
    //{ data: 'LeaseStructure' }


    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      "pageLength": 50,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
      },
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/property/portfolioProperties/' + that.property.Guid + '/' + this.user.Id, dataTablesParameters).subscribe(resp => {

            this.portfolioProperties = resp.data ? resp.data : [];
            if (this.propertyRevisionModel.PropertyIds != null) {
              this.portfolioProperties.forEach(item => {

                item.IsSelected = this.propertyRevisionModel.PropertyIds.indexOf(item.Id) > -1 ? true : false;
              })
            }
            else if (this.propertyRevisionModel.RevisionId == 0) {
              this.onSelectAll(true);
              this.selectAll = true;
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
          });
        this._loaderService.display(false);
      },
      columns: that.TableColumns
    };
  }
  selectedProps = [] as any;
  onCheckboxChange(checked, Id) {
    if (checked) {
      this.selectedProps.push(Id);
    }
    else {
      this.selectedProps.splice(this.selectedProps.findIndex(x => x == Id), 1);
    }

  }

  onSelectAll(isChecked) {
    if (isChecked) {
      this.portfolioProperties.forEach(item => {

        item.IsSelected = true;
        this.selectedProps.push(item.Id);
      });
    }
    else {
      this.portfolioProperties.forEach(item => {

        item.IsSelected = false;
        this.selectedProps.splice(this.selectedProps.findIndex(x => x == item.Id), 1);
      });
    }
  }
}
